import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, interval, timer } from 'rxjs';
import { startWith, switchMap, takeUntil, takeWhile } from 'rxjs/operators';
import { PaymentService } from 'src/app/services/payment.service';

// Tiempo máximo esperando la confirmación del webhook de Mercado Pago antes de resolverse
// al último estado conocido (el redirect de MP o la última respuesta del polling).
const POLLING_TIMEOUT_MS = 30000;
const POLLING_INTERVAL_MS = 3000;

@Component({
    selector: 'app-tenants-payment-form-sended',
    templateUrl: './tenants-payment-form-sended.component.html',
    styleUrls: ['./tenants-payment-form-sended.component.scss']
})
export class TenantsPaymentFormSendedComponent implements OnInit, OnDestroy {

    warrantyHash: string;
    // Mientras se confirma el estado real contra el backend (el query param de MP es solo informativo).
    verificando = true;
    // Si volvimos de Mercado Pago con un estado que no sea "approved" (rechazo, pendiente, etc.)
    // la operación no se concretó y hay que ofrecer reintentar en vez de agradecer.
    operacionConcretada = true;

    private pollingSubscription?: Subscription;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private paymentService: PaymentService,
    ) { }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.warrantyHash = params.id;
            // Estado inicial optimista en base al redirect de MP, mientras se confirma con el backend.
            this.operacionConcretada = !params.status || params.status === 'approved';
            if (this.warrantyHash) {
                this.pollPaymentStatus();
            } else {
                this.verificando = false;
            }
        });
    }

    ngOnDestroy(): void {
        this.pollingSubscription?.unsubscribe();
    }

    private pollPaymentStatus() {
        this.pollingSubscription = interval(POLLING_INTERVAL_MS).pipe(
            startWith(0),
            switchMap(() => this.paymentService.getPaymentStatus(this.warrantyHash)),
            takeWhile(status => status.estadoUltimaOperacion === 'LINK_GENERADO', true),
            takeUntil(timer(POLLING_TIMEOUT_MS)),
        ).subscribe({
            next: status => {
                if (status.estadoUltimaOperacion === 'APROBADA') {
                    this.operacionConcretada = true;
                    this.verificando = false;
                } else if (status.estadoUltimaOperacion === 'RECHAZADA') {
                    this.operacionConcretada = false;
                    this.verificando = false;
                }
            },
            complete: () => this.verificando = false,
            error: () => this.verificando = false,
        });
    }

    reintentar() {
        this.router.navigate(['/inquilinos/pago'], { queryParams: { id: this.warrantyHash } });
    }

}
